import React, { useState, useEffect, useMemo } from 'react';
/* global axios */
import api from '../services/apiService';
import moment from 'moment';
import 'moment/locale/de';
import Modal from 'react-modal';
import Select from 'react-select';
import { Helmet } from 'react-helmet';

moment.locale('de');
Modal.setAppElement('#root');

const EmployeeCalendarWithWorkshopAssignments = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    return localStorage.getItem('selectedDate') || moment().format('YYYY-MM-DD');
  });
  const [workshopOrders, setWorkshopOrders] = useState([]);
  const [assignmentSchedules, setAssignmentSchedules] = useState([]);
  const [transports, setTransports] = useState([]); // Neue State-Variable für Transporte
  const [isLoading, setIsLoading] = useState(true);
  const [roleFilters, setRoleFilters] = useState(() => {
    const storedFilters = localStorage.getItem('roleFilters');
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          Fahrer: true,
          Service: true,
          Hilfskraft: true,
          Disponent: true,
          Vertrieb: true,
        };
  });
  const roleSortOrder = ['Fahrer', 'Service', 'Hilfskraft', 'Disponent', 'Vertrieb'];

 // Neuer State für Pagination
 const [currentPage, setCurrentPage] = useState(1);
 const [totalPagesWO, setTotalPagesWO] = useState(1);  
 const limit = 25;


  useEffect(() => {
    localStorage.setItem('selectedDate', selectedDate);
  }, [selectedDate]);
  
  useEffect(() => {
    localStorage.setItem('roleFilters', JSON.stringify(roleFilters));
  }, [roleFilters]);


  /**
 * Öffnet das PDF mit der kompletten TimeLog-Historie
 * für den gegebenen WorkshopOrder im neuen Tab.
 */
const handleDownloadHistoryPdf = async (workshopOrderId) => {
  try {
    // Wichtig: responseType 'blob' + dein api-Instance sendet automatisch Auth-Header
    const res = await api.get(`/employeeTimeLogs/history/${workshopOrderId}/pdf`, {
      responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // neue Registerkarte öffnen
    window.open(url, '_blank');

    // später aufräumen
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (err) {
    console.error('History-PDF konnte nicht geladen werden:', err);
    alert('Kein Zugriff oder keine Historie gefunden (siehe Konsole).');
  }
};


// Öffnet das Werkstattauftrag-PDF im neuen Tab
const handleOpenWorkshopOrderPdf = (workshopOrderId) => {
  const baseURL = api.defaults.baseURL || ''; // z.B. http://localhost:3001
  const url = `${baseURL}/documents/workshoporder/${workshopOrderId}/pdf`;
  window.open(url, '_blank');
};

  
  // Filter-State: Wir speichern hier den ausgewählten Wert (als String) oder null.
  const [woFilters, setWoFilters] = useState({
    workshopOrderNumber: null,
    orderNumber: null,
    customer: null,
    date: null,
    plannedExecuteDate: null,
    fulfillmentDate: null,
    status: null,
    workshopOrderType: null,
    blockedPeriodFrom: null,
    blockedPeriodTo: null,
    itemName: null,  // neu: itemName statt machineName
    detail: null
  });

   // State für serverseitige Filteroptionen
   const [serverFilterOptions, setServerFilterOptions] = useState({});
   const [woFilterOptions, setWoFilterOptions] = useState({});

  // Modal-Dialog-States für neue Zuordnung
  const [assignmentModalVisible, setAssignmentModalVisible] = useState(false);
  const [modalOrder, setModalOrder] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [modalStartTime, setModalStartTime] = useState('');
  const [modalEndTime, setModalEndTime] = useState('');

  // Modal-Dialog-States für das Editieren eines bestehenden Schedules
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [editStartTime, setEditStartTime] = useState('');
  const [editEndTime, setEditEndTime] = useState('');

  

  // Mitarbeiter laden
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get('/employees');
        setEmployees(response.data);
      } catch (error) {
        console.error('Fehler beim Abrufen der Mitarbeiter:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchEmployees();
  }, []);

  
 // NEU: Workshopaufträge (Liste unten) laden – reagiert auf Filter & Pagination
useEffect(() => {
  const fetchWorkshopOrders = async () => {
    try {
      const q = buildWorkshopOrdersQuery();
      const res = await api.get(`/workshoporders/list${q}`);
       const rows = (res.data.data || []).map(wo => {
   const direct = wo.item?.name ?? null; // falls es in Zukunft doch mal direkt kommt
   const fromFirstPosition = wo.workshopOrderItems?.[0]?.item?.name ?? null;
   return {
     ...wo,
     __displayItemName: direct ?? fromFirstPosition ?? ''
   };
 });
 setWorkshopOrders(rows);
      setTotalPagesWO(res.data.pages || 1);
    } catch (err) {
      console.error('Fehler beim Laden der Workshopaufträge:', err);
    }
  };
  fetchWorkshopOrders();
}, [woFilters, currentPage]);

  // Bei Filterwechsel wieder auf Seite 1 springen
useEffect(() => {
  setCurrentPage(1);
}, [
  woFilters.workshopOrderNumber,
  woFilters.status,
  woFilters.workshopOrderType,
  woFilters.orderNumber,
  woFilters.customer,
  woFilters.itemName,
  woFilters.detail,
  woFilters.date,
  woFilters.plannedExecuteDate,
  woFilters.fulfillmentDate,
  woFilters.blockedPeriodFrom,
  woFilters.blockedPeriodTo
]);


// buildQuery: Hier wird nun itemName statt machineName gesendet
 // Nur für die Planungs-Tafel (Schedules) – entkoppelt von Tabellenfiltern
 const buildSchedulesQuery = () => {
   const p = new URLSearchParams();
   p.append('date', selectedDate);
   return `?${p.toString()}`;
 };

// NEU: Querybuilder speziell für die Werkstattaufträge-Liste unten
const buildWorkshopOrdersQuery = () => {
  const p = new URLSearchParams();

  if (woFilters.workshopOrderNumber) p.append('workshopOrderNumber', woFilters.workshopOrderNumber.value);
  if (woFilters.status)             p.append('status', woFilters.status.value);
  if (woFilters.workshopOrderType)  p.append('workshopOrderType', woFilters.workshopOrderType.value);
  if (woFilters.orderNumber)        p.append('orderNumber', woFilters.orderNumber.value);

  if (woFilters.date)               p.append('date', woFilters.date.value);
  if (woFilters.plannedExecuteDate) p.append('plannedExecuteDate', woFilters.plannedExecuteDate.value);
  if (woFilters.fulfillmentDate)    p.append('fulfillmentDate', woFilters.fulfillmentDate.value);
  if (woFilters.blockedPeriodFrom)  p.append('blockedPeriodFrom', woFilters.blockedPeriodFrom.value);
  if (woFilters.blockedPeriodTo)    p.append('blockedPeriodTo', woFilters.blockedPeriodTo.value);

  // Kunde (Firmenname)
  if (woFilters.customer)           p.append('customer', woFilters.customer.value);

  // WICHTIG: Notes/Details
  if (woFilters.detail)             p.append('detail', woFilters.detail.value);

  // Maschine (Item-Name) – nur anhängen, sobald du ihn unten im UI setzt
  if (woFilters.itemName)           p.append('itemName', woFilters.itemName.value);

  p.append('limit', limit);
  p.append('page', currentPage);

  return `?${p.toString()}`;
};


  // Assignment Schedules für das ausgewählte Datum laden
useEffect(() => {
   const fetchSchedules = async () => {
     try {
       const query = buildSchedulesQuery(); // nur ?date=YYYY-MM-DD
       const res = await api.get(`/employeeAssignmentSchedules/list${query}`);
       setAssignmentSchedules(res.data.data);
     } catch (error) {
       console.error("Fehler beim Abrufen der Schedules:", error);
     }
   };
   fetchSchedules();
 }, [selectedDate]); // <— nur Datum


  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/employeeAssignmentSchedules/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

// NEU: Filteroptionen für die Werkstattaufträge-Tabelle unten
useEffect(() => {
  const fetchWoFilterOptions = async () => {
    try {
      const res = await api.get('/workshoporders/filter-options');
      setWoFilterOptions(res.data);
    } catch (err) {
      console.error('Fehler beim Laden der WorkshopOrder-Filteroptionen:', err);
    }
  };
  fetchWoFilterOptions();
}, []);



  // Transporte für das ausgewählte Datum laden
  useEffect(() => {
    const fetchTransports = async () => {
      try {
        const response = await api.get('/transports', {
          params: { scheduledDate: selectedDate },
        });
        setTransports(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Transporte:', error);
      }
    };
    fetchTransports();
  }, [selectedDate]);

  // Hilfsfunktion: Assignment erstellen oder abrufen
  const createOrGetAssignment = async (workshopOrderId, employeeId) => {
    const wId = parseInt(workshopOrderId, 10);
    const eId = parseInt(employeeId, 10);
    try {
      const response = await api.post('/employeeAssignments', {
        workshopOrderId: wId,
        employeeId: eId,
      });
      return response.data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.includes('existiert bereits')
      ) {
        try {
          const res = await api.get('/employeeAssignments', {
            params: { workshopOrderId: wId, employeeId: eId },
          });
          if (res.data && res.data.length > 0) {
            const found = res.data.find(a => a.employeeId === eId);
            return found || null;
          }
        } catch (getError) {
          console.error('Fehler beim Abrufen des existierenden Assignments:', getError);
        }
      } else {
        console.error('Fehler beim Erstellen des Assignments:', error);
      }
      return null;
    }
  };

  // Hilfsfunktion, um nur "HH:mm" zurückzugeben (falls nötig)
  const formatTimeWithoutSeconds = (timeStr) => {
    return timeStr && timeStr.length >= 5 ? timeStr.substring(0, 5) : timeStr;
  };

  // Hilfsfunktion: Schedule anlegen
  const createSchedule = async (assignmentId, plannedStartTime, plannedEndTime) => {
    try {
      const response = await api.post(`/employeeAssignmentSchedules/${assignmentId}`, {
        date: selectedDate,
        plannedStartTime,
        plannedEndTime,
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Erstellen des Schedules:', error);
      return null;
    }
  };

  // Öffnet den Modal-Dialog für neue Zuordnung
  const openAssignmentModal = (workshopOrder) => {
    setModalOrder(workshopOrder);
    setSelectedEmployeeId('');
    setModalStartTime('');
    setModalEndTime('');
    setAssignmentModalVisible(true);
  };

  const handleModalSubmit = async () => {
  if (!selectedEmployeeId || !modalStartTime || !modalEndTime) {
    alert('Bitte Mitarbeiter, Start- und Endzeit angeben.');
    return;
  }

  const formattedStartTime = formatTimeWithoutSeconds(modalStartTime);
  const formattedEndTime   = formatTimeWithoutSeconds(modalEndTime);

  const assignment = await createOrGetAssignment(modalOrder.id, selectedEmployeeId);
  if (!assignment) return;

  const schedule = await createSchedule(assignment.id, formattedStartTime, formattedEndTime);
  if (schedule) {


    // Schedules neu laden
    const res = await api.get(`/employeeAssignmentSchedules/list?date=${selectedDate}`);
    setAssignmentSchedules(res.data.data);

    // (optional) Liste neu laden – kosmetisch, falls du Flags brauchst
    const q = buildWorkshopOrdersQuery();
    const woRes = await api.get(`/workshoporders/list${q}`);
    const rows = (woRes.data.data || []).map(wo => {
      const direct = wo.item?.name ?? null;
      const fromFirstPosition = wo.workshopOrderItems?.[0]?.item?.name ?? null;
      return { ...wo, __displayItemName: direct ?? fromFirstPosition ?? '' };
    });
    setWorkshopOrders(rows);
    setTotalPagesWO(woRes.data.pages || 1);
  }

  setAssignmentModalVisible(false);
  setModalOrder(null);
};



  // Inline-Edit: Öffnet den Modal-Dialog zum Bearbeiten eines bestehenden Schedules
  const openEditModal = (schedule) => {
    setEditingSchedule(schedule);
    // Hier wird ein Dummy-Datum ("2000-01-01") hinzugefügt, damit Moment.js den Zeitstring korrekt parst.
    setEditStartTime(moment(`2000-01-01 ${schedule.plannedStartTime}`, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'));
    setEditEndTime(moment(`2000-01-01 ${schedule.plannedEndTime}`, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'));
    setEditModalVisible(true);
  };

  const handleEditSubmit = async () => {
    if (!editStartTime || !editEndTime) {
      alert('Bitte Start- und Endzeit angeben.');
      return;
    }
    
    // Direkt nur "HH:mm" verwenden
    const formattedEditStart = formatTimeWithoutSeconds(editStartTime);
    const formattedEditEnd = formatTimeWithoutSeconds(editEndTime);
    
    try {
      const response = await api.put(`/employeeAssignmentSchedules/${editingSchedule.id}`, {
        plannedStartTime: formattedEditStart,
        plannedEndTime: formattedEditEnd,
      });
      if (response.data) {
        setAssignmentSchedules(prev =>
          prev.map(sch => (sch.id === response.data.id ? response.data : sch))
        );
      }
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Schedules:', error);
    }
    setEditModalVisible(false);
    setEditingSchedule(null);
  };

// --- NEU: flexible Parser für "HH:mm:ss" oder "HH:mm"
const parseSlotTime = (dateStr, timeStr) => {
  return moment(`${dateStr} ${timeStr}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);
};

// --- NEU: prozentuale Überlappung eines Intervals innerhalb einer Stunden-Zelle
const getOverlapSegmentPct = (slotStart, slotEnd, start, end) => {
  const segStart = moment.max(slotStart, start);
  const segEnd   = moment.min(slotEnd, end);
  const minutes  = segEnd.diff(segStart, 'minutes');

  if (minutes <= 0) return null;

  const leftPct  = (segStart.diff(slotStart, 'minutes') / 60) * 100; // 0–100
  const widthPct = (minutes / 60) * 100;                             // 0–100
  return { leftPct, widthPct };
};


  // Füge direkt nach handleEditSubmit in der Component-Funktion ein:
const handleDeleteSchedule = async () => {
  if (!editingSchedule) return;
  if (window.confirm("Möchtest du diesen Schedule wirklich löschen?")) {
    try {
       await api.delete(`/employeeAssignmentSchedules/${editingSchedule.id}`);
 const res = await api.get(`/employeeAssignmentSchedules/list?date=${selectedDate}`);
 setAssignmentSchedules(res.data.data);

      // Workshopaufträge neu laden (Flag kann wieder auf false fallen, wenn letzte Assignment weg)
      const q = buildWorkshopOrdersQuery();
      const woRes = await api.get(`/workshoporders/list${q}`);
      const rows = (woRes.data.data || []).map(wo => {
        const direct = wo.item?.name ?? null;
        const fromFirstPosition = wo.workshopOrderItems?.[0]?.item?.name ?? null;
        return { ...wo, __displayItemName: direct ?? fromFirstPosition ?? '' };
      });
      setWorkshopOrders(rows);
      setTotalPagesWO(woRes.data.pages || 1);

      setEditModalVisible(false);
      setEditingSchedule(null);
    } catch (error) {
      console.error("Fehler beim Löschen des Schedules:", error);
      alert("Fehler beim Löschen des Schedules");
    }
  }
};


  const headerSlots = useMemo(() => {
    const headers = [];
    let time = moment(selectedDate).startOf('day');
    const end = moment(selectedDate).endOf('day');
    while (time.isBefore(end)) {
      if (time.minute() === 0) headers.push(time.clone());
      time.add(30, 'minutes');
    }
    return headers;
  }, [selectedDate]);

  const goToPreviousDay = () => {
    setSelectedDate(moment(selectedDate).subtract(1, 'day').format('YYYY-MM-DD'));
  };
  const goToNextDay = () => {
    setSelectedDate(moment(selectedDate).add(1, 'day').format('YYYY-MM-DD'));
  };

// Falls du die Filteroptionen clientseitig (aus dem Server) in den Dropdowns nutzen möchtest:
  // Beispielhafte Variablen aus serverFilterOptions können mittels useMemo erstellt werden.
  const optionsOrderNumber = useMemo(() => {
    return serverFilterOptions.workshopOrderNumbers?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  const optionsOrderType = useMemo(() => {
    return serverFilterOptions.workshopOrderTypes?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  const optionsCustomer = useMemo(() => {
    return serverFilterOptions.customers?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  const optionsItemName = useMemo(() => {
    return serverFilterOptions.machineNames?.map(val => ({ value: val, label: val })) || [];
    // Falls im Backend der Key "itemName" statt "machineNames" verwendet wird, passe dies hier entsprechend an.
  }, [serverFilterOptions]);

  const optionsDetails = useMemo(() => {
    return serverFilterOptions.details?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  const optionsStatus = useMemo(() => {
    return serverFilterOptions.statuses?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  const optionsPlannedDate = useMemo(() => {
    return serverFilterOptions.plannedExecuteDates?.map(val => ({ value: val, label: val })) || [];
  }, [serverFilterOptions]);

  // NEU: Dropdown-Optionen für die Workshopaufträge (kommen aus /workshoporders/filter-options)
const woOptionsOrderNumber = useMemo(
  () => woFilterOptions.workshopOrderNumbers?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsOrderType = useMemo(
  () => woFilterOptions.workshopOrderTypes?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsCustomer = useMemo(
  () => woFilterOptions.customers?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsPlannedDate = useMemo(
  () => woFilterOptions.plannedExecuteDates?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsStatus = useMemo(
  () => woFilterOptions.statuses?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsOrderNumbers = useMemo(
  () => woFilterOptions.orderNumbers?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsBlockedFrom = useMemo(
  () => woFilterOptions.blockedPeriodFromDates?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsBlockedTo = useMemo(
  () => woFilterOptions.blockedPeriodToDates?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
const woOptionsFulfillmentDate = useMemo(
  () => woFilterOptions.fulfillmentDates?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
// NEU: Details/Notes
const woOptionsDetails = useMemo(
  () => woFilterOptions.details?.map(v => ({ value: v, label: v })) || [],
  [woFilterOptions]
);
// Optional: Maschine, falls dein /filter-options das liefert
const woOptionsMachine = useMemo(() => {
   // 1) Wenn /workshoporders/filter-options machineNames liefert, nutze die:
   const apiNames = woFilterOptions.machineNames?.filter(Boolean) || [];
   if (apiNames.length > 0) {
     return apiNames.map(v => ({ value: v, label: v }));
   }
   // 2) Fallback: aus den bereits geladenen WorkshopOrders ableiten
   const names = (workshopOrders || [])
     .map(wo => wo.__displayItemName)
     .filter(Boolean);
   const unique = Array.from(new Set(names));
   return unique.map(v => ({ value: v, label: v }));
 }, [woFilterOptions, workshopOrders]);



  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }

   // Filtere und sortiere die Mitarbeiter vor der Darstellung
   const filteredAndSortedEmployees = employees
   .filter(emp => emp.status === 'verfügbar' && roleFilters[emp.role])
   .sort((a, b) => {
     // Zuerst nach der definierten Rollenreihenfolge sortieren
     const roleComparison = roleSortOrder.indexOf(a.role) - roleSortOrder.indexOf(b.role);
     if (roleComparison !== 0) return roleComparison;
     // Innerhalb derselben Rolle nach dem sortOrder-Feld sortieren
     return a.sortOrder - b.sortOrder;
   });

  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div className="calendar-container">
      <Helmet>
              <title>Servicekalender</title>
              <meta name="Servicekalender" content="Servicekalender" />
            </Helmet>
      <h2></h2>
      
      {/* Rechte Spalte – Rollenfilter */}
     <div style={{
      maxWidth: 350,
      border: '1px solid #aaa',
      margin: 16,
      padding: 8,
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}>
      {Object.keys(roleFilters).map(role => (
        <label key={role} >
          <input
            type="checkbox"
            checked={roleFilters[role]}
            onChange={() =>
              setRoleFilters(prev => ({ ...prev, [role]: !prev[role] }))
            }
            style={{ marginRight: '5px' }}
          />
          {role}
        </label>
      ))}
    </div>
  </div>
  
  
      <div
  style={{
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    /* kein justify-content hier! */
  }}
>
  {/* Linke Spalte (kann leer sein oder weitere Inhalte enthalten) */}
    <div style={{ flex: 1 }} />
    {/* Optional: Hier könnten z.B. weitere Filter oder Infos platziert werden */}
 

  {/* Mittlere Spalte – zentriert */}
  <div style={{ flex: 'none', textAlign: 'center' }}>
    <div
  style={{
    margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
  }}
>
      <button onClick={goToPreviousDay}>&lt;</button>
      <div>
        <h3 style={{ margin: 0 }}>{moment(selectedDate).format('dddd, DD.MM.YYYY')}</h3>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>
      <button onClick={goToNextDay}>&gt;</button>
    </div>
  </div>


   {/* Rechte Spalte – Rollenfilter */}
  <div
    style={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }}
  >
    
  </div>
  
 
</div>


      {/* Kalenderansicht */}
      <table className="calendar-table" style={{ marginTop: '20px' }}>
        <thead>
          <tr>
            <th>Mitarbeiter</th>
            {headerSlots.map(slot => (
              <th key={slot.format('HH:mm')}>{slot.format('HH:mm')}</th>
            ))}
          </tr>
        </thead>
        <tbody>
        {filteredAndSortedEmployees.map(employee => (
            <tr key={employee.id}>
              <td>
      {employee.firstName} {employee.lastName}<br />
      <small>{employee.role}</small>
    </td>
             {headerSlots.map(slot => {
  // Jede Kopfspalte repräsentiert weiterhin eine volle Stunde (12:00–13:00)
  const slotStart = slot.clone().minute(0).second(0);
  const slotEnd   = slotStart.clone().add(1, 'hour');

  // Alle Schedules des Mitarbeiters, die diese Stunde schneiden
  const schedulesInHour = assignmentSchedules.filter(sch => {
    if (sch.assignment?.employeeId !== employee.id) return false;
    const start = parseSlotTime(sch.date, sch.plannedStartTime);
    const end   = parseSlotTime(sch.date, sch.plannedEndTime);
    return start.isBefore(slotEnd) && end.isAfter(slotStart);
  });

  // Alle Transporte des Mitarbeiters, die diese Stunde schneiden
  const transportsInHour = transports.filter(t => {
    if (t.driverId !== employee.id) return false;
    const start = parseSlotTime(t.scheduledDate, t.timeframeFrom);
    const end   = parseSlotTime(t.scheduledDate, t.timeframeTo);
    return start.isBefore(slotEnd) && end.isAfter(slotStart);
  });

  // Stapelhöhe für mehrere Balken in der gleichen Stunde
  const BAR_H = 14;
  const GAP   = 2;
  let row     = 0;

return (
  <td
    key={slot.format('HH:mm')}
    style={{
      border: '1px solid #ccc',
      minWidth: '50px',
      height: '40px',
      position: 'relative',
      padding: 0,
      cursor: (schedulesInHour.length || transportsInHour.length) ? 'pointer' : 'default',
      overflow: 'hidden',
    }}
    onClick={() => {
      if (schedulesInHour.length > 0) openEditModal(schedulesInHour[0]);
    }}
  >
    {(() => {
      // 1) Schedule als "Vollhöhen-Block"
      if (schedulesInHour.length > 0) {
        const sch   = schedulesInHour[0]; // primären nehmen; Rest als Badge anzeigen
        const start = parseSlotTime(sch.date, sch.plannedStartTime);
        const end   = parseSlotTime(sch.date, sch.plannedEndTime);
        const seg   = getOverlapSegmentPct(slotStart, slotEnd, start, end);
        if (seg) {
          return (
            <>
              <div
                title={`${start.format('HH:mm')} – ${end.format('HH:mm')} • ${sch.assignment?.workshopOrder?.workshopOrderNumber || 'Auftrag'}`}
                style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,                // <<< volle Höhe
                  left: `${seg.leftPct}%`,
                  width: `${seg.widthPct}%`,
                  background: 'rgb(41, 112, 253)',
                  color: 'white',
                  borderRadius: 0,
                  fontSize: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'auto',
                }}
                onClick={(e) => { e.stopPropagation(); openEditModal(sch); }}
              >
                {sch.assignment?.workshopOrder?.workshopOrderNumber || 'WA'}
              </div>

              {schedulesInHour.length > 1 && (
                <div
                  style={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    background: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    borderRadius: 8,
                    padding: '0 6px',
                    fontSize: 10,
                  }}
                  title={`+${schedulesInHour.length - 1} weitere Zuordnung(en) in dieser Stunde`}
                >
                  +{schedulesInHour.length - 1}
                </div>
              )}
            </>
          );
        }
      }

      // 2) Falls kein Schedule, aber Transport: ebenfalls Vollhöhe (mit Transparenz)
      if (transportsInHour.length > 0) {
        const t     = transportsInHour[0];
        const start = parseSlotTime(t.scheduledDate, t.timeframeFrom);
        const end   = parseSlotTime(t.scheduledDate, t.timeframeTo);
        const seg   = getOverlapSegmentPct(slotStart, slotEnd, start, end);
        if (seg) {
          return (
            <div
              title={`Transport ${start.format('HH:mm')} – ${end.format('HH:mm')}`}
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,               // <<< volle Höhe
                left: `${seg.leftPct}%`,
                width: `${seg.widthPct}%`,
                background: 'rgba(255, 0, 85, 0.8)',
                color: 'white',
                borderRadius: 0,
                fontSize: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {`${start.format('HH:mm')}-${end.format('HH:mm')}`}
            </div>
          );
        }
      }

      return null;
    })()}
  </td>
);

})}

            </tr>
          ))}
        </tbody>
      </table>
      

      {/* Filterzeile als Dropdowns in Spaltenbreite */}
      <div style={{ marginTop: '50px', margin: '20px 20px' }}>
        <h3></h3>
         <div className="filter-grid"
          
        >
          {/* Auftrag */}
          <Select
            options={woOptionsOrderNumber} 
            placeholder="Auftrag"
            isClearable
            value={woFilters.workshopOrderNumber}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, workshopOrderNumber: selected })
            }
          />
          {/* Typ */}
          <Select
            options={woOptionsOrderType} 
            placeholder="Typ"
            isClearable
            value={woFilters.workshopOrderType}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, workshopOrderType: selected })
            }
          />
          {/* Kunde */}
          <Select
            options={woOptionsCustomer}  
            placeholder="Kunde"
            isClearable
            value={woFilters.customer}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, customer: selected })
            }
          />
          {/* ItemName (Maschine) */}
          <Select
            options={woOptionsMachine} 
            placeholder="Maschine"
            isClearable
            value={woFilters.itemName}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, itemName: selected })
            }
          />
          {/* Details */}
          <Select
            options={woOptionsDetails}
            placeholder="Details"
            isClearable
            value={woFilters.detail}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, detail: selected })
            }
          />
          {/* Status */}
          <Select
            options={woOptionsStatus}
            placeholder="Status"
            isClearable
            value={woFilters.status}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, status: selected })
            }
          />
          {/* Erledigungsdatum */}
          <Select
            options={woOptionsPlannedDate} 
            placeholder="Erledigungsdatum"
            isClearable
            value={woFilters.plannedExecuteDate}
            onChange={(selected) =>
              setWoFilters({ ...woFilters, plannedExecuteDate: selected })
            }
          />
          <div>{/* Letzte Spalte: keine Filterung für Aktion */}</div>
        </div>
      </div>


      {/* Workshopaufträge-Tabelle */}
      <h3></h3>
      <table className="workshoplist" style={{
        tableLayout: 'auto',
        width: '100%',
      }}>
        <thead>
          <tr>
            <th>Auftrag</th>
            <th>Typ</th>
            <th>Kunde</th>
            <th>Maschine</th>
            <th>Details</th>
            <th>Status</th>
            <th>gepl. Erledigungsdatum</th>
            <th>Aktion</th>
             <th>Historie</th>
          </tr>
        </thead>
        <tbody>
          {workshopOrders.length > 0 ? (
            workshopOrders.map(workshopOrder => (
              <tr key={workshopOrder.id}>
                <td>{workshopOrder.workshopOrderNumber}</td>
                <td>{workshopOrder.workshopOrderType}</td>
                <td>{workshopOrder.customer ? `${workshopOrder.customer.company} (${workshopOrder.customer.customerNumber || '-'})` : ''}</td>
                <td>
  {workshopOrder.item?.name
   ?? workshopOrder.workshopOrderItems?.[0]?.item?.name
   ?? ''}
</td>
                <td>
              {workshopOrder.notes && workshopOrder.notes.length > 50
                ? workshopOrder.notes.substring(0, 50) + "..."
                : workshopOrder.notes}
              </td>
                <td>{workshopOrder.status}</td>
                <td>
                  {workshopOrder.plannedExecuteDate
                    ? moment(workshopOrder.plannedExecuteDate).format('DD.MM.YYYY')
                    : ''}
                </td>
                <td>
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {/* PDF-Button (grün mit Auge) */}
    <button
      onClick={() => handleOpenWorkshopOrderPdf(workshopOrder.id)}
      title="Werkstattauftrag als PDF ansehen"
      aria-label="Werkstattauftrag als PDF ansehen"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        width: '32px',
        height: '28px',
        cursor: 'pointer',
      }}
    >
      👁️
    </button>

    {/* vorhandener Zuordnen-Button */}
    <button
      onClick={() => openAssignmentModal(workshopOrder)}
      style={{
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '0.3em 0.6em',
        cursor: 'pointer'
      }}
    >
      Zuordnen
    </button>
  </div>
</td>


                <td>
  <button
    onClick={() => handleDownloadHistoryPdf(workshopOrder.id)}
    title="TimeLog-Historie als PDF"
    style={{
      background: 'none',
      border: 'none',
      color: '#007bff',
      textDecoration: 'underline',
      cursor: 'pointer',
      padding: 0,
      fontSize: '0.9em'
    }}
  >
    PDF
  </button>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                Es wurden keine Workshopaufträge gefunden.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
  <button
    onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
    disabled={currentPage === 1}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Vorherige
  </button>

  {/* Anzeige der aktuellen Seite */}
  <span>
    Seite {currentPage} von {totalPagesWO}
  </span>

  <button
    onClick={() => setCurrentPage(currentPage < totalPagesWO ? currentPage + 1 : totalPagesWO)}
    disabled={currentPage === totalPagesWO}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Nächste
  </button>
</div>
      

      {/* Modal für neue Zuordnung */}
      <Modal
        isOpen={assignmentModalVisible}
        onRequestClose={() => setAssignmentModalVisible(false)}
        contentLabel="Assignment erstellen"
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 1000 },
          content: { maxWidth: '400px', margin: 'auto', padding: '20px', zIndex: 1001 },
        }}
      >
        <h2>Assignment erstellen</h2>
        {modalOrder && (
           <>
           <p>
             Workshopauftrag: <strong>{modalOrder.workshopOrderNumber}</strong> ({modalOrder.workshopOrderType})
           </p>
           {modalOrder.notes && (
             <p>
               Notizen: {modalOrder.notes}
             </p>
           )}
         </>
        )}
        <div style={{ marginBottom: '1em' }}>
          <label>Mitarbeiter:</label>
          <select
            value={selectedEmployeeId}
            onChange={(e) => setSelectedEmployeeId(e.target.value)}
            style={{ marginLeft: '10px' }}
          >
            <option value="">-- auswählen --</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>
                {emp.firstName} {emp.lastName} ({emp.role})
              </option>
            ))}
          </select>
        </div>
        <div style={{ marginBottom: '1em' }}>
          <label>Startzeit (HH:mm):</label>
          <input
            type="time"
            value={modalStartTime}
            onChange={(e) => setModalStartTime(e.target.value)}
            style={{ marginLeft: '10px' }}
          />
        </div>
        <div style={{ marginBottom: '1em' }}>
          <label>Endzeit (HH:mm):</label>
          <input
            type="time"
            value={modalEndTime}
            onChange={(e) => setModalEndTime(e.target.value)}
            style={{ marginLeft: '10px' }}
            
          />
 
        </div>
        <button onClick={handleModalSubmit}>Speichern</button>
        <button onClick={() => setAssignmentModalVisible(false)} style={{ marginLeft: '10px' }}>
          Abbrechen
        </button>
      </Modal>

      {/* Modal für Schedule bearbeiten */}
      <Modal
        isOpen={editModalVisible}
        onRequestClose={() => setEditModalVisible(false)}
        contentLabel="Schedule bearbeiten"
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 1100 },
          content: { maxWidth: '400px', height: '650px', margin: 'auto', padding: '20px', zIndex: 1101 },
        }}
      >
        <h2>Schedule bearbeiten</h2>
        {editingSchedule && editingSchedule.assignment && editingSchedule.assignment.workshopOrder && (
          <div>
            <p>
              Auftrag:{' '}
              <strong>
                {editingSchedule.assignment.workshopOrder.workshopOrderNumber}
              </strong>
            </p>
            <p>
  Typ:{' '}
  <strong>
    {editingSchedule.assignment.workshopOrder.workshopOrderType || 'Kein Typ'}
  </strong>
</p>
            <p>
              Maschine:{' '}
              <strong>
                {editingSchedule.assignment.workshopOrder.item
                  ? editingSchedule.assignment.workshopOrder.item.name
                  : 'Keine Maschine'}
              </strong>
            </p>
            <p>
              Kunde:{' '}
              <strong>
                {editingSchedule.assignment.workshopOrder.customer
                  ? editingSchedule.assignment.workshopOrder.customer.company
                  : 'Kein Kunde'}
              </strong>
            </p>
            <p>
              Gepl. Erledigungsdatum:{' '}
              <strong>
                {editingSchedule.assignment.workshopOrder.plannedExecuteDate
                  ? moment(editingSchedule.assignment.workshopOrder.plannedExecuteDate).format('DD.MM.YYYY')
                  : 'Kein Datum'}
              </strong>
            </p>
            <p>
      Notizen:{' '}
      <strong>
        {editingSchedule.assignment.workshopOrder.notes || 'Keine Notizen'}
      </strong>
    </p>
          </div>
        )}
        <div style={{ marginBottom: '1em' }}>
          <label>Startzeit (HH:mm):</label>
          <input
            type="time"
            value={editStartTime}
            onChange={(e) => setEditStartTime(e.target.value)}
            style={{ marginLeft: '10px' }}
          />
        </div>
        <div style={{ marginBottom: '1em' }}>
          <label>Endzeit (HH:mm):</label>
          <input
            type="time"
            value={editEndTime}
            onChange={(e) => setEditEndTime(e.target.value)}
            style={{ marginLeft: '10px' }}
          />
        </div>
        <button onClick={handleEditSubmit}>Speichern</button>
        <button onClick={() => setEditModalVisible(false)} style={{ marginLeft: '10px' }}>
          Abbrechen
        </button>
        <button 
  onClick={handleDeleteSchedule} 
  style={{ marginLeft: '10px', backgroundColor: '#dc3545', color: 'white',  }}
>
  Löschen
</button>
      </Modal>
      
    </div>
  );
};

export default EmployeeCalendarWithWorkshopAssignments;
